export const isIOrWe = (currentInvitee) => {
  if (currentInvitee?.additionalGuests.length > 0 && currentInvitee?.rsvp?.additionalGuests.some(resp => resp)) {
    return "We";
  }
  return "I";
}

export const isAfterRSVPDate = () => {
  return Date.now() > Date.parse("2024/12/16 00:00:00");
}

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export const getCookie = (cname) => {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}